import { props, resolveObject } from 'cerebral/tags'
import createSnackbar from 'modules/App/factories/createSnackbar'
import reorderItem from '../actions/reorderItem'
import setOrder from 'modules/App/actions/setOrder'

export default [
  reorderItem,
  setOrder,
  createSnackbar(
    resolveObject({
      key: 'bms.orderHistory.reorderedItem',
      params: resolveObject({ name: props`name` })
    })
  )
]



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/chains/reOrderBasketItem.js